import React from "react"
import Dante from "../images/IMG_2736.jpg"
import { Link } from "react-router-dom"

import { AnimationOnScroll } from 'react-animation-on-scroll';


export default function AboutPage(){
    return(

        <section className="about-sec text-gray-600 body-font overflow-hidden" id="about">
        <div className="container px-5 py-24 mx-auto" >
        <AnimationOnScroll initiallyVisible={true} animateIn="animate__jello" duration={7}>
            <div className="lg:w-4/5 mx-auto flex flex-wrap">
                <img alt="ecommerce" className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded" src={Dante}></img>
                <div className="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
                    <h2 className="text-sm title-font text-gray-500 tracking-widest">Just a Dev</h2>
                    <h1 className="text-purple-600 text-3xl title-font font-medium mb-1">WALOBWA DAN</h1>
                    <div className="flex mb-4">
                        <span className="flex items-center">
                            <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-4 h-4 text-purple-500" viewBox="0 0 24 24">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                            </svg>
                            <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-4 h-4 text-purple-500" viewBox="0 0 24 24">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                            </svg>
                            <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-4 h-4 text-purple-500" viewBox="0 0 24 24">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                            </svg>
                            <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-4 h-4 text-purple-500" viewBox="0 0 24 24">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                            </svg>
                            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-4 h-4 text-purple-500" viewBox="0 0 24 24">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                            </svg>
                            <span className="text-gray-600 ml-3">Skills Rating</span>
                        </span>
                        <Link to ="/skills" class="text-purple-500 border-l-2 border-gray-400 flex space-x-2s items-center pt-4 ml-3 pl-3 p3-2">View Skills
                            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                <path d="M5 12h14M12 5l7 7-7 7"></path>
                            </svg>
                        </Link>
                    </div>
                    <p className="leading-relaxed">
                    Telecommunication Eng. X Software Eng. with a strong pracitcal experience of web development. Responsible for designing, developing, testing and maintaining web applications that are efficient, reliable and easy to use. I have experience with a variety of programming languages and platforms, and have worked on projects of all sizes. A quick learner and open to working on challenging problems.</p>
                    <br></br>
                
                    <h3 className="text-2xl font-light">Languages:</h3>
                    <p><em>Python, JavaScript, PHP, Shell</em></p>
                    <br></br>
                    <h3 className="text-2xl font-light">Frameworks, Tools & Libraries:</h3>
                    <p><em>React, Django, Laravel, Docker, MySQL, Postgress, MongoDB Tailwind, Bootstrap, SCSS/SASS, Three.js, Figma</em></p>
                    <br></br>
                    <h3 className="text-2xl font-light">Other Tools:</h3>
                    <p><em>SQL, HTML5, CSS3</em></p>
                </div>
            </div>
        </AnimationOnScroll>
        </div>
    </section>
    )
}